<template>
  <!--在线签到系统-->
  <div>
    <div class="mj_one">
      <p>{{ config.name }}</p>
      <p>签到类型：{{ config.type === 0 ? "单点签到" : "多点签到" }}</p>
      <template v-if="config.type === 1">
        <p>是否线性：{{ config.isLinear ? "是" : "否" }}</p>
        <p>是否强制：{{ config.isStrictLinear ? "是" : "否" }}</p>
      </template>
    </div>
    
    <ul class="qd_type qd_type2">
      <li
        v-for="(oper, index) in operation"
        :key="index"
        :class="{ sel: oper.key == currentComponent }"
        @click="changeComponent(oper.key)"
      >
        {{ oper.value }}
      </li>
    </ul>

    <template v-if="companyList.length == 0">
      <component :is="currentComponent" @search="search" :value.sync="value" :btnLoading="btnLoading" />
      <div class="dl_type"></div>
      <ul class="mj_six qd_two">
        <li>
          <img src="@/assets/img/q1.png" alt="" />
          <h2 class="num">{{ statistic.aggregate }}</h2>
          <p>报名总数</p>
        </li>
        <li>
          <img src="@/assets/img/q2.png" alt="" />
          <h2 class="num">{{ statistic.signed }}</h2>
          <p>已签到</p>
        </li>
        <li>
          <img src="@/assets/img/q3.png" alt="" />
          <h2 class="num">{{ statistic.notSigned }}</h2>
          <p>未签到</p>
        </li>
      </ul>

      <div class="mj_seven">详细数据可往现场管理系统中进行查询</div>
    </template>
    <template v-else>
      <ul class="pz_two qd_three">
        <li v-for="(page, index) in pagedData" :key="index">
          <div class="left" @click="getDetail(page)">
            <p class="title" style="text-align: left">{{ page.company }}</p>
            <p class="title" style="text-align: left">{{ page.name }}</p>
          </div>
          <img src="@/assets/img/q3.png" class="img" />
        </li>
      </ul>

      <div class="page" v-if="companyList.length > 1">
        <span @click="prevPage">
          {{ currentPage == 0 ? "没有了" : "上一页" }}
        </span>
        <div @click="back" class="fan">返回</div>
        <span @click="nextPage">
          {{
            currentPage >= (companyList.length - 1) / itemsPerPage
              ? "没有了"
              : "下一页"
          }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import Accurate from "./components/Accurate.vue";
import Vague from "./components/Vague.vue";
import Team from "./components/Team.vue";
import ScanCode from "./components/ScanCode.vue";
import { mapGetters } from "vuex";
import Banner from "@/assets/img/banner.png";
import Footer from "@/assets/img/footer.png";
import Modal from "ant-design-vue/lib/modal/Modal";
import { validateURL } from "@/utils/util";

export default {
  name: "",
  components: {
    Accurate,
    Vague,
    Team,
    ScanCode,
  },
  data() {
    return {
      tabid: 0,
      btnLoading: false,
      operation: [
        { key: "Accurate", value: "精确查询" },
        { key: "Vague", value: "模糊查询" },
        { key: "Team", value: "团体签到" },
        { key: "ScanCode", value: "扫码签到" },
      ],
      companyList: [],
      currentComponent: "Accurate",
      currentPage: 0, // 当前页码
      itemsPerPage: 5, // 每页显示的元素数量
      value: "",
      statistic: {
        aggregate: 0, // 总人数
        signed: 0, // 已签到
        notSigned: 0, // 未签到
      },
    };
  },
  watch: {
    value() {
      console.log(123);
    },
  },
  mounted() {
    const alias = this.$route.query.alias;
    const configuration = this.$route.query.conf;
    const state = this.$route.query.state;
    !!alias && !!configuration && this.getStatistic(alias, configuration);
    !!state && this.changeComponent(state);
  },
  computed: {
    pagedData() {
      // 使用computed计算属性来获取分页后的数据
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.companyList.slice(start, end);
    },
    ...mapGetters({
      config: "signStore/getConfig",
    }),
    getBanner() {
      return this.config.banner || Banner;
    },
    getFooter() {
      return this.config.footer || Footer;
    },
  },
  methods: {
    validateURL,
    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.companyList.length / this.itemsPerPage) {
        this.currentPage += 1;
      }
    },
    changeComponent(component) {
      this.companyList = [];
      this.currentComponent = component;
      const path = this.$route.path;
      const { alias, conf } = this.$route.query;
      this.$router.push({
        path: path,
        query: {
          alias: alias,
          conf: conf,
          state: component,
        },
        replace: true,
      });
    },
    async getStatistic(groupId, pointId) {
      const res = await this.$get(`/api/CheckIn/GetStatistic/${groupId}/${pointId}`);
      if (res.code === 200) {
        this.statistic = { ...res.data };
      }
    },
    async search(formData) {
      this.btnLoading = true;
      const { signMode } = formData;
      const { alias, conf } = this.$route.query;
      const res = await this.$get(`/api/CheckIn/Search/${alias}/${conf}`, formData).finally(() => {
        this.btnLoading = false;
      });

      if (res.code === 200) {
        if (!res.data || !res.data.length) {
          const { isShowModal } = this.config;
          if (isShowModal == 1) {
            Modal.confirm({
              centered: true,
              title: this.config.modalTitle,
              content: this.config.modalContent,
              okText: this.config.modalConfirmButtonText,
              cancelText: this.config.modalCancelButtonText,
              onOk: () => {
                if(!this.validateURL(this.config.modalConfirmButtonEnterUrl)) {
                  this.$message.open({
                    type: "error",
                    duration: 2,
                    maxCount: 3,
                    content: "跳转链接解析错误",
                  });
                  return;
                }
                const dom = document.createElement("a");
                dom.href = this.config.modalConfirmButtonEnterUrl;
                dom.target = this.config.modalWindowTarget || "_self";
                dom.click();
              }
            });
          } else {
            this.$message.warning("未查询到数据");
          }
          return;
        }

        if (res.data && res.data.length == 1) {
          this.$router.push(
            `/sign/signin?alias=${alias}&conf=${conf}&state=${signMode}&r=${res.data[0].id}`
          );
          return;
        }
        this.companyList = [...res.data];
      } else {
        this.$message.error(res.message);
      }
    },
    emitSearch(formData) {
      this.search(formData);
    },
    getDetail(item) {
      const mode = this.currentComponent;
      const alias = this.$route.query.alias;
      const configuration = this.$route.query.conf;
      this.$router.push(
        `/sign/signin?alias=${alias}&conf=${configuration}&state=${mode}&r=${item.id}`
      );
    },
    back() {
      // this.$router.go(-1);
      this.companyList = [];
    },
  },
};
</script>

<style></style>
